import { render, staticRenderFns } from "./combinedResult.vue?vue&type=template&id=fda95e6c&scoped=true"
import script from "./combinedResult.vue?vue&type=script&lang=js"
export * from "./combinedResult.vue?vue&type=script&lang=js"
import style0 from "./combinedResult.vue?vue&type=style&index=0&id=fda95e6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda95e6c",
  null
  
)

export default component.exports